import React from 'react';
import './../../styles/mobileSearchBar.css';
import { crawlerDuplicateAvoidStyle } from '../../utils/commonUtils';

export const IrctcAuthorizedPartner = () => {
  const title = 'IRCTC Authorized Partner';
  return (
    <>
      <div style={crawlerDuplicateAvoidStyle} className={'textCenter mobileShow irctc-widget'}>
        <span className={'icon'} />
        <span className={'authorizedPartner'}>{title}</span>
      </div>
      <div className={'desktopShow irctc-widget'}>
        <div className={'authorizedPartner'}>
          <span className={'icon'} />
          <span>{title}</span>
        </div>
      </div>
    </>
  );
};

export default IrctcAuthorizedPartner;
